import GlobalApi from '../../services/Global';
import UserApi from '../../services/UserData';
import {mutation} from './mutations';
import {storage} from '../../services/config/storage';
import {SESSION_URL} from '../../services/config/apiUrl';
import CompanyApi from 'services/CompanyData';
import {alphaSort} from 'utils/sorting';
import moment from 'moment';
import {MODALS, WATCHLIST_KEYS} from 'utils/constants';
import {abortAllApiCalls} from 'services/config/request';
import qs from 'qs';
import axios from 'axios';
import {findRouteDefaultPath} from '../../utils/helpers';

const handleError = (err) => {
    console.log('Error in company action : ', err);
};

export const getPortfolioDetails = (payload) => async (dispatch) => {
    try {
        const res = await GlobalApi.getPortfolioDetails(payload);
        return res;
    } catch (err) {
        handleError(err);
    }
};

export const getEntityPortfolio = (payload) => async (dispatch) => {
    try {
        return await GlobalApi.getPortList(payload);
    } catch (err) {
        handleError(err);
    }
};

export const getUserPorfolio = () => async (dispatch) => {
    try {
        const res = await GlobalApi.getUserPortfolio();
        if (Array.isArray(res)) {
            dispatch(mutation.setUserPortfolio(res));
            return res;
        }
    } catch (err) {
        handleError(err);
    }
};

export const getAllWatchlisted = () => async (dispatch, getState) => {
    const {
        global: {userPortfolio, user},
    } = getState();
    if (
        userPortfolio.length === 0 &&
        !user.limited_access &&
        user.userAccess?.watchlistAccess === '1'
    )
        await dispatch(getUserPorfolio());
    return await Promise.all(
        Object.keys(WATCHLIST_KEYS).map((entityType) =>
            dispatch(getWatchList(entityType)),
        ),
    );
};

export const getWatchList = (entityType) => async (dispatch, getState) => {
    try {
        const {
            global: {userPortfolio, user},
        } = getState();
        if (user.userAccess?.watchlistAccess !== '0') {
            if (
                user.limited_access &&
                user.userAccess?.watchlistAccess !== '1'
            ) {
                return [];
            }
            let userPort = userPortfolio;
            if (userPort.length === 0)
                userPort = await dispatch(getUserPorfolio());
            const Name =
                userPort.filter((p) => p === WATCHLIST_KEYS[entityType])[0] ??
                {};
            const params = {
                entityType:
                    entityType.toLowerCase() === 'credit'
                        ? 'CreditStrategy'
                        : entityType.toLowerCase() === 'digitalassets'
                        ? 'DigitalAssets'
                        : entityType.toLowerCase() === 'industry'
                        ? 'IndustryTemplate'
                        : entityType.toLowerCase() === 'currency'
                        ? 'FXTemplate'
                        : entityType.toLowerCase() === 'rate'
                        ? 'RateTemplate'
                        : entityType.toLowerCase() === 'country'
                        ? 'CountryTemplate'
                        : entityType.charAt().toUpperCase() +
                          entityType.slice(1),
                userPortName: Name,
                pageSize: 1000,
            };
            const entityList =
                Name && typeof Name != 'object'
                    ? await GlobalApi.getShortlistingEntityInfo(params)
                    : [];
            if (entityList) {
                dispatch(mutation.setWatchList({entityType, entityList}));
            }
            return entityList;
        }
    } catch (e) {
        handleError(e);
    }
};

export const setHelpVideoLink = (p) => async (dispatch) => {
    try {
        const res = await GlobalApi.getGlobalProps(p);
        if (res?.propValue) dispatch(mutation.setHelpVideo(res.propValue));
        return;
    } catch (err) {
        handleError(err);
    }
};
export const setModalVisible = (payload) => async (dispatch) => {
    try {
        dispatch(mutation.setModalVisibility(payload));
    } catch (e) {
        handleError(e);
    }
};
export const toggleFromWatchlist =
    ({ricsHash: entityList, entityType, ...restPayload}) =>
    async (dispatch, getState) => {
        try {
            const {
                global: {user},
            } = getState();
            if (
                user?.limited_access &&
                user.userAccess?.watchlistAccess !== '1'
            ) {
                dispatch(setActiveModal(MODALS.PRO_MINUS_PWD));
            } else {
                restPayload.portState = 'active';
                const res = await GlobalApi.watchList(restPayload);
                if (!restPayload.id) {
                    // If ID isn't present that means that the portfolio wasn't created until now,
                    // so will need to fetch user portfolio again to get the newly created ID.
                    dispatch(getUserPorfolio());
                }
                if (res) {
                    dispatch(
                        mutation.toggleFromWatchlist({entityType, entityList}),
                    );
                }
                return res;
            }
            return;
        } catch (e) {
            handleError(e);
        }
    };

// TODO: Make sigle watchlist action
export const watchlistToggle =
    ({addEntity, removeEntity, entityType}) =>
    async (dispatch, getState) => {
        const {user, userPortfolio} = getState().global;
        const {userId} = user;
        const portfolio = userPortfolio.filter(
            (port) => port.Name === WATCHLIST_KEYS[entityType],
        );
        const {id = null} = portfolio[0] ?? {};
        const latestDate = moment
            .tz(moment(), 'Asia/Singapore')
            .format('YYYY-MM-DD HH:mm:ss');
        const params = {
            userId,
            id,
            addEntity,
            removeEntity,
            landingEnable: 0,
            portOrder: 0,
            topEnable: 0,
            updateDate: latestDate,
            portState: 'active',
            name: WATCHLIST_KEYS[entityType],
        };
        const res = await GlobalApi.watchList(params);
        if (!id) {
            // If ID isn't present that means that the portfolio wasn't created until now,
            // so will need to fetch user portfolio again to get the newly created ID.
            await dispatch(getUserPorfolio());
            dispatch(getWatchList(entityType));
        }
        return res;
    };

export const getS3Files = (p, options) => async (dispatch) => {
    try {
        const res = await GlobalApi.getS3Files(p, options);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const getfinancialExcelDownload = (p) => async (dispatch) => {
    try {
        const res = await GlobalApi.getfinancialExcelDownload(p);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const saveS3FilesRequest = (file, p) => async (dispatch) => {
    try {
        const res = await GlobalApi.saveS3Files(file, p);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const listS3FilesRequest = (p) => async (dispatch) => {
    try {
        const res = await GlobalApi.listS3Files(p);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const sendFeedBack = (feedback) => async (dispatch) => {
    try {
        const res = await GlobalApi.sendFeedBack(feedback);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const logUiEvents = (p) => async (dispatch) => {
    try {
        const res = await GlobalApi.logUiEvents(p);
        return res;
    } catch (e) {
        handleError(e);
        return e;
    }
};

export const getShareUrls = (p) => async (dispatch) => {
    try {
        const query = qs.stringify(p);
        const res = await GlobalApi.getEntityUrl(query);
        if (res) dispatch(setShareUrls(res));
        return res;
    } catch (err) {
        handleError(err);
    }
};

export const getPortfolioUrl = (p) => async (dispatch) => {
    try {
        const res = await GlobalApi.getPortfolioUrl(p);
        if (res) dispatch(setShareUrls(res.urls));
        return res;
    } catch (err) {
        handleError(err);
    }
};

export const getEntityChartMetadata = (p) => async (dispatch) => {
    try {
        const res = await GlobalApi.getEntityChartMetadata(p);
        return res;
    } catch (err) {
        handleError(err);
    }
};

export const setAnalystData = (p) => async (dispatch) => {
    const {
        otherAnalysts,
        analystStatus,
        bio,
        analystId,
        analystName,
        analystDesignation,
        askAnalyst,
        emailId,
        imageUrl,
        phone,
        leadBio,
        leadAnalystId,
        leadAnalystName,
        leadAnalystDesignation,
        leadEmailId,
        leadImageUrl,
        ...rest
    } = p;
    dispatch(
        mutation.setAnalystData({
            otherAnalysts,
            analystStatus: analystStatus && analystStatus !== 'UNAVAILABLE',
            bio,
            analystId,
            analystName,
            analystDesignation,
            askAnalyst,
            emailId,
            imageUrl,
            phone,
            leadBio,
            leadAnalystId,
            leadAnalystName,
            leadAnalystDesignation,
            leadEmailId,
            leadImageUrl,
        }),
    );
    return rest;
};

export const addOtherAnalystData = (payload) => (dispatch) => {
    try {
        dispatch(mutation.setOtherAnalystData(payload));
    } catch (e) {
        handleError(e);
    }
};

export const getRecentDevelopment =
    (id, isCountry = false, entityType = 'Company') =>
    async (dispatch, getState) => {
        try {
            const {
                global: {user},
            } = getState();
            let res = {};
            if (user.role === 'Free User') {
                res = await CompanyApi.getRecentDevelopmentPartial(id);
            } else {
                res = await CompanyApi.getRecentDevelopment(id);
            }
            const hasAnalystLevelAccess = [
                'Admin',
                'Analyst',
                'Production',
            ].includes(user.role);
            const rdsUrls = {};
            if (hasAnalystLevelAccess) {
                const rdList = isCountry
                    ? await CompanyApi.getRecentDevCountryUrls({companyId: id})
                    : id.startsWith('IN')
                    ? await CompanyApi.getRecentDevIndustryUrls({companyId: id})
                    : await CompanyApi.getRecentDevUrls({
                          companyId: id,
                          entityType,
                      }); // getting URLs from different api
                rdList.forEach((rd) => (rdsUrls[rd.id] = rd.urlLinks));
            }
            const data = hasAnalystLevelAccess
                ? res.map((rd) => ({...rd, urlLinks: rdsUrls[rd.id]}))
                : res;
            if (Array.isArray(data)) {
                const sortedData = alphaSort(data, 'date', -1);
                const whatsnew = sortedData.filter(
                    (item) =>
                        moment(item.date) >= moment().subtract(90, 'days') &&
                        item.enabled,
                );
                let analystReports = sortedData.filter(
                    (item) =>
                        moment(item.date) < moment().subtract(90, 'days') &&
                        item.enabled,
                );
                if (whatsnew.length > 5) {
                    // BD-1025: What's New will only show top 5 ideas that are within 30 days
                    // Add rest of them to analyst reports
                    analystReports = whatsnew.splice(5).concat(analystReports);
                }
                dispatch(
                    mutation.setRecentDevelopments({whatsnew, analystReports}),
                );
            }
            return;
        } catch (e) {
            handleError(e);
        }
    };

export const setShareUrls = (p) => (dispatch) =>
    dispatch(mutation.setShareUrls(p));

export const setShareUrlsTitle = (p) => (dispatch) =>
    dispatch(mutation.setShareUrlsTitle(p));

export const setPwdChangePopup = (flag) => (dispatch) =>
    dispatch(mutation.setPwdChangePopup(flag));

export const grantAccess =
    (user, justLoggedIn = false) =>
    async (dispatch) => {
        const userData = {...user, limited_access: !user.usedPassword};
        // if (!storage?.fetch.userDetails()) {
        //     storage.set.userDetails(userData);
        //     storage.destroy.session();
        //     localStorage.setItem('justLoggedIn', justLoggedIn);
        //     localStorage.setItem(
        //         'newsletterSubscribed',
        //         userData?.userProps?.vickersNewsletterEDMOptIn,
        //     );

        //     let resp = await axios.get(
        //         SESSION_URL + storage?.fetch.userDetails()?.sessionId,
        //     );

        //     storage.set.session(resp?.data.session);
        //     storage.set.sessionExpiry(resp?.data.sessionExpiration);
        //     dispatch(mutation.setUserDetails(userData));
        //     dispatch(mutation.setAuth(true));
        //     dispatch(getAllWatchlisted());
        // } else if (
        //     user?.usedPassword === 1 &&
        //     window.location.href.includes('corporateaccess')
        // ) {
        //     storage.set.userDetails(userData);
        //     storage.destroy.session();
        //     // localStorage.setItem('justLoggedIn', justLoggedIn);
        //     // localStorage.setItem(
        //     //     'newsletterSubscribed',
        //     //     userData?.userProps?.vickersNewsletterEDMOptIn,
        //     // );

        //     let resp = await axios.get(
        //         SESSION_URL + storage?.fetch.userDetails()?.sessionId,
        //     );

        //     storage.set.session(resp?.data.session);
        //     storage.set.sessionExpiry(resp?.data.sessionExpiration);
        //     dispatch(mutation.setUserDetails(userData));
        //     dispatch(mutation.setAuth(true));
        //     dispatch(getAllWatchlisted());
        // } else {
        //     dispatch(mutation.setUserDetails(userData));
        //     dispatch(mutation.setAuth(true));
        //     dispatch(getAllWatchlisted());

        //     let resp = await axios.get(
        //         SESSION_URL + storage?.fetch.userDetails()?.sessionId,
        //     );
        //     storage.set.userDetails(userData);
        //     storage.destroy.session();
        //     localStorage.setItem('justLoggedIn', justLoggedIn);
        //     localStorage.setItem(
        //         'newsletterSubscribed',
        //         userData?.userProps?.vickersNewsletterEDMOptIn,
        //     );
        //     storage.set.session(resp?.data.session);
        //     storage.set.sessionExpiry(resp?.data.sessionExpiration);
        // }
        storage.set.userDetails(userData);
        storage.destroy.session();
        localStorage.setItem('justLoggedIn', justLoggedIn);
        localStorage.setItem(
            'newsletterSubscribed',
            userData?.userProps?.vickersNewsletterEDMOptIn,
        );

        // let resp = await axios({
        //     method: 'post',
        //     url: SESSION_URL,
        //     headers: {},
        //     data: {
        //         sessionId: storage?.fetch.userDetails()?.sessionId,
        //     },
        // });
        //
        // storage.set.session(resp?.data.session);
        // storage.set.sessionExpiry(resp?.data.sessionExpiration);
        dispatch(mutation.setUserDetails(userData));
        dispatch(mutation.setAuth(true));
        dispatch(getAllWatchlisted());
    };

export const updateUserDetails = (data) => (dispatch) =>
    dispatch(mutation.setUserDetails(data));

export const setEmailFreqOptions = (data) => (dispatch) =>
    dispatch(mutation.setEmailFreqOptions(data));

export const setHelperPage = (flag) => (dispatch) =>
    dispatch(mutation.setHelperPage(flag));

export const setIsFreeShareUrlDisabled = (flag) => (dispatch) =>
    dispatch(mutation.setIsFreeShareUrlDisabled(flag));

export const setActiveModal = (name) => (dispatch) =>
    dispatch(mutation.setActiveModal(name));

export const login =
    ({emailId, password, guest = false, skipLogout = false}) =>
    async (dispatch, getState) => {
        try {
            let res;
            if (guest) {
                res = await GlobalApi.loginFreeUser();
            } else {
                res = await GlobalApi.loginUser({
                    emailId,
                    password,
                    roleName: 'User',
                });
                if (res?.login) {
                    let resp = await axios({
                        method: 'post',
                        url: SESSION_URL,
                        headers: {},
                        data: {
                            sessionId: res.sessionId,
                        },
                    });
                    storage.set.session(resp?.data.session);
                    storage.set.userDetails(res);
                    storage.set.sessionExpiry(resp?.data.sessionExpiration);
                    res = await GlobalApi.getUserDetails();
                }
            }
            if (res?.login) {
                const {
                    global: {user},
                } = getState();
                dispatch(grantAccess(res, user.userId !== res.userId));
            } else {
                if (!skipLogout) dispatch(logoutApp());
            }
            return res;
        } catch (err) {
            handleError(err);
            return false;
        }
    };

export const loginWithoutPwd = (payload) => async (dispatch) => {
    try {
        const res = await GlobalApi.loginUser({...payload, roleName: 'User'});
        if (res?.login) {
            dispatch(grantAccess({...res}));
            return res;
        }
        // dispatch(mutation.setAuth(false))
        return res;
    } catch (err) {
        handleError(err);
        return false;
    }
};

export const loginAsGuest = () => async (dispatch) => {
    try {
        const res = await dispatch(login({guest: true}));
        return !!res.login;
    } catch (e) {
        handleError(e);
        return false;
    }
};

export const checkAuth = (from, isProtected, router) => async (dispatch) => {
    try {
        const {sessionId, role, ...rest} = storage.fetch.userDetails() ?? {};
        // if sessionId present verify session;
        // In case of Free User:
        //  - clear user session for unprotected routes
        //    and redirect to respective route
        if (sessionId && !(role === 'Free User' && !isProtected)) {
            const res = await UserApi.VerifyLogin();
            let resUserData = rest;
            let newRole = role;
            let newSessionId = sessionId;
            if (res) {
                resUserData = await GlobalApi.getUserDetails();
                newRole = resUserData?.role;
                newSessionId = resUserData?.sessionId;
            }

            if (!!res?.status) {
                dispatch(
                    grantAccess({
                        ...resUserData,
                        role: newRole,
                        sessionId: newSessionId,
                    }),
                );
                router.replace(
                    findRouteDefaultPath(
                        resUserData?.uiPageMenu,
                        isProtected && from ? from : '/landingpage',
                    ),
                );
                return;
            }
        }
        // Give free access if protected route
        if (isProtected) {
            const guestResult = await dispatch(loginAsGuest());
            if (!!guestResult) {
                dispatch(mutation.setAuth(true));
                router.replace(from ?? '/landingpage');
                return;
            }
        }
        dispatch(logoutApp());
        router.push(from ?? '/home');
        return;
    } catch (e) {
        handleError(e);
        return false;
    }
};

export const logoutApp = () => async (dispatch) => {
    try {
        const user = storage.fetch.userDetails();
        if (user) {
            abortAllApiCalls();
            GlobalApi.logout();
        }
        dispatch(clearSession());
    } catch (e) {
        handleError(e);
    }
};

export const getEntityPDF = (payload) => async (dispatch) => {
    try {
        return await GlobalApi.getEntityPDF(payload);
    } catch (err) {
        handleError(err);
    }
};

export const clearSession = () => (dispatch) => {
    storage.destroy.userDetails();
    storage.destroy.session();
    storage.destroy.sessionExpiry();
    dispatch(mutation.logout());
    return;
};
